'use strict';

import {emailInput} from '../models/email-input';
import {form} from '../models/form'

function createRequestNewPasswordForm(requestNewPasswordForm) {
  var emailField = emailInput.create(requestNewPasswordForm.querySelector('.email-input'));

  form.create(requestNewPasswordForm, [emailField]);
}

function init() {
  var requestNewPasswordForm = document.querySelector('.request-new-password-form');
  if (requestNewPasswordForm) {
    createRequestNewPasswordForm(requestNewPasswordForm);
  }
}

if ('querySelector' in document) {
  init();
}
